import * as React from "react";
import Button from "@mui/material/Button";
import "../../Theme/main.scss";
import {
  Backdrop,
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Formik, Form, FormikValues, FormikProps } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import ShortcutButton from "../../Components/ShortcutButton";
import { useContext, useEffect, useRef, useState } from "react";
import { PreferencesContext } from "../../PreferencesContext";
import { AlertType } from "../../shared/Modal/AlertType";
import SplashComponent from "../../Navigation/splash";
import { EncryptDecryptService } from "../../Services/common/EncryptionService";
import Title from "../../Components/Title";
import { handleFocus, isElementVisible } from "../../shared/CommonFuctions";
import CustomAutoFocus from "../../Components/CustomAutoFocus";
import { PAGE_SIZE } from "../../Services/common/const";
import {
  GetLastProductDetail,
  GetProductTypeList,
} from "../../Services/CategoryProductService";
import { GetDetail as GetBranchDetail } from "../../Services/BranchService";
import { GetTaxList } from "../../Services/TaxService";
import { GetUnitList } from "../../Services/UnitService";
import { GetExpenseAccountList } from "../../Services/ExpenseVoucherService";
import { PopupDialog } from "../../Components/PopupDialog";
import AccountGroupSave from "../AccountGroup/AccountGroupSave";
import UnitSave from "../Unit/UnitSave";
import TaxSave from "../Tax/TaxSave";
import { CreatePartyType, GetPartyTypeDetail, UpdatePartyType } from "../../Services/PartyTypeService";

interface TaxModal {
  label: string;
  value: string;
  code: string;
}

export default function PartyTypeSave(props: any) {
  const formikRef = useRef<any>(null);
  const { code, isForPopup, handleUnitChange, name, handleCloseorOpenpopup, pageType } =
    props;

  interface PartyTypeValues extends FormikValues {
    buyerSupplierPartyId: number;
    code: string;
    name: string;
    partyTypeCode: string;
  }

  const formInitialValues: PartyTypeValues = {
    buyerSupplierPartyId: 0,
    code: "",
    name: code,
    partyTypeCode: "",
  };

  const parameters: any = {
    pageIndex: 1,
    pageSize: PAGE_SIZE,
    sortColumn: "",
    sortDirection: "",
    searchValue: "",
  };

  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [isLoading, setLoading] = useState(false);
  const { setInputRef } = CustomAutoFocus(isForPopup, true);
  const [isSubmitting, setSubmitting] = useState(false);
  const [isAllowAdd, setAllowAdd] = useState(true);
  const [page_Index, setPage_Index] = useState(1);
  const [param, setParam] = useState(parameters);
  const [resultData, setResultData] = useState<any>([]);
  const edService = new EncryptDecryptService();
  let navigate = useNavigate();

  const [productType, setProductType] = useState([]);
  const [radioSelected, setRadioSelected] = useState(1);
  const [partyTypeInitial, setPartyTypeInitial] = useState({
    ...formInitialValues,
    name: isForPopup && isForPopup !== undefined ? name : "",
    financialYear: userContext.financialYear,
  });

  const [taxcode, setTaxCode] = useState("");
  const [openCreateTaxPopup, setOpenCreateTaxPopup] = useState(false);
  const [openCreateAccount, setOpenCreateAccount] = React.useState(false);
  const [ledgerAccount, setLedgerAccount] = React.useState({});
  const [openCreateUnit, setOpenCreateUnit] = React.useState(false);
  const [unitName, setUnitName] = React.useState("");

  function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const PartyType = () => {
    if (!isForPopup) {
      navigate(-1);
    } else {
      handleCloseorOpenpopup(code);
    }
  };

  let urlParams = useQuery();
  let curRawPartyTypeId = urlParams.get("q");
  let pItemTypeName = urlParams.get("t") || pageType;
  let curPartyTypeId = 0;
  if (!isForPopup) {
    if (curRawPartyTypeId !== null && curRawPartyTypeId !== undefined) {
      let decId = edService.decrypt(curRawPartyTypeId);
      if (decId !== "" && decId !== null && decId !== undefined) {
        curPartyTypeId = +decId;
      } else {
        navigate("/not-found");
      }
    } else {
      navigate("/not-found");
    }
  }
  const [buyerSupplierPartyId, setBuyerSupplierPartyId] = useState(curPartyTypeId);

  //Get Data
  async function fetchData() {
    try {
      setLoading(true);
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("buyerSupplierPartyId", buyerSupplierPartyId.toString());
      params.append("partyTypeCode", pItemTypeName === "buyer" ? "BUYER" : "SUPPLIER");
      const result: any = await GetPartyTypeDetail(params);
      let editDetails = result.data.data;
      let updatedValue = {
        buyerSupplierPartyId: editDetails.buyerSupplierPartyId,
        code: editDetails.code,
        name: editDetails.name,
        partyTypeCode: pItemTypeName === "buyer" ? "BUYER" : "SUPPLIER",
      };
      setLoading(false);
      setPartyTypeInitial(updatedValue);
    }
    catch (e: any) {
      setLoading(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  async function SubmitPartyType(value: any) {
    setSubmitting(true);
    try {
      let partyTypeData = value;
      const isEditMode = !isForPopup && buyerSupplierPartyId > 0;
      let SavePartyType = {
        buyerSupplierPartyId: isEditMode ? buyerSupplierPartyId : 0,
        consumerId: userContext.consumerId,
        firmId: userContext.firmId,
        branchId: userContext.branchId,
        code: partyTypeData.code?.trim(),
        name: partyTypeData.name?.trim(),
        dataManagedBy: userContext.userId,
        partyTypeCode: pItemTypeName === "buyer" ? "BUYER" : "SUPPLIER",
      };
      let partyTypeResult: any;
      if (isEditMode) {
        partyTypeResult = await UpdatePartyType(SavePartyType);
      } else {
        partyTypeResult = await CreatePartyType(SavePartyType);
      }
      if (partyTypeResult && partyTypeResult.data === true) {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: partyTypeResult.message,
          alertType: AlertType.Success,
        });
        if (isForPopup === true) {
          handleCloseorOpenpopup(SavePartyType);
        } else {
          navigate(-1);
        }
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: partyTypeResult?.message || "Unable to save Party Type.",
          alertType: AlertType.Error,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string"
            ? e
            : e?.message || "An unexpected error occurred.",
        alertType: AlertType.Error,
      });
    } finally {
      setSubmitting(false);
    }
  }

  const formikPropsRef = React.useRef<FormikProps<PartyTypeValues> | null>(
    null
  );

  const handleFocusOnKeyDown = (event: any) => {
    if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
      let form = event.target.form;
      let index = Array.prototype.indexOf.call(form, event.target);
      let Elements = form.elements;

      let nextIndex = index + 2;
      while (
        (nextIndex < Elements.length &&
          !isElementVisible(Elements[nextIndex])) ||
        Elements[nextIndex]?.disabled === true
      ) {
        nextIndex++;
      }
      if (nextIndex < Elements.length) {
        Elements[nextIndex].focus();
      }
      event.preventDefault();
    }
  };

  useEffect(() => {
    if (buyerSupplierPartyId > 0) {
      fetchData();
    }
  }, []);

  React.useEffect(() => {
    document.addEventListener("keydown", handleFocusOnKeyDown);
    const handleShortcut = (event: CustomEvent) => {
      if (event.detail && event.detail.type === "save" && formikRef.current) {
        validateAndSubmitIncomeExpenseItemForm(formikRef.current);
      }
    };
    window.addEventListener("appShortcut", handleShortcut as EventListener);
    return () => {
      document.removeEventListener("keydown", handleFocusOnKeyDown);
      window.removeEventListener("appShortcut", handleShortcut as EventListener);
    };
  }, []);

  const hasValidationErrors = (errors: any): boolean => {
    if (!errors) return false;
    if (typeof errors === "string") return true;
    if (Array.isArray(errors)) return errors.some((item) => hasValidationErrors(item));
    if (typeof errors === "object") return Object.values(errors).some((value) => hasValidationErrors(value));
    return false;
  };

  const buildTouchedFromValues = (values: any): any => {
    if (Array.isArray(values)) return values.map((item) => buildTouchedFromValues(item));
    if (values !== null && typeof values === "object") {
      return Object.keys(values).reduce((acc: any, key) => {
        acc[key] = buildTouchedFromValues(values[key]);
        return acc;
      }, {});
    }
    return true;
  };

  const validateAndSubmitIncomeExpenseItemForm = async (formikInstance: any) => {
    if (!formikInstance) return;
    const errors = await formikInstance.validateForm();
    if (hasValidationErrors(errors)) {
      formikInstance.setTouched(buildTouchedFromValues(formikInstance.values), true);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: "Please fill highlighted fields!",
        alertType: AlertType.Error,
      });
      return;
    }
    await formikInstance.submitForm();
  };

  return (
    <>
      <Title pageTitle={"Expense Item"} />
      <Formik
        innerRef={formikRef}
        enableReinitialize
        initialValues={partyTypeInitial}
        initialTouched={{
          buyerSupplierPartyId: true,
          code: true,
          name: false,
        }}
        onSubmit={(values) => {
          SubmitPartyType(values);
        }}
        validateOnBlur={false}
        validateOnMount
        validationSchema={Yup.object().shape({
          code: Yup.string().trim(),
          name: Yup.string().trim().required("Name is required."),
          partyTypeCode: Yup.string().nullable(),
          buyerSupplierPartyId: Yup.number().nullable(),
        })}>
        {(props) => {
          return (
            <React.Fragment>
              <Backdrop
                sx={{
                  color: "#fff",
                  backgroundColor: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={isLoading}>
                <SplashComponent />
              </Backdrop>
              <Box
                className="boxContainer PageCenter"
                sx={{
                  maxWidth: "500px",
                  marginTop: isForPopup ? "0px !important" : "16px",
                }}>
                <Box sx={{ width: "100%" }}>
                  <h4
                    className="page-title"
                    style={{
                      borderBottom: isForPopup ? "1px solid #ced4da" : "none",
                      padding: isForPopup ? "16px" : "0px !important",
                      width: "100%",
                      position: isForPopup ? "sticky" : "static",
                      top: "0px",
                      zIndex: 9,
                    }}>
                    {buyerSupplierPartyId > 0
                      ? `Edit ${pItemTypeName === "buyer" ? "Buyer" : "Supplier"} Party Type`
                      : `Add ${pItemTypeName === "buyer" ? "Buyer" : "Supplier"} Party Type`}
                  </h4>
                </Box>
                <Grid className="paper" width={"100%"}>
                  <Paper
                    elevation={1}
                    className={!isForPopup ? "paper-container" : ""}
                    sx={{
                      border: isForPopup
                        ? "none !important"
                        : "1px solid $card-border-color",
                    }}>
                    <Form onSubmit={props.handleSubmit} noValidate>
                      <Grid
                        container
                        spacing={2}
                        paddingX={isForPopup ? 1 : 0}
                        marginTop={isForPopup ? 0.25 : 0}
                        className="GridMobileView">
                        <Grid item xs={12}>
                          <FormControl fullWidth>
                            <TextField
                              id="code"
                              label="Code"
                              fullWidth
                              size="small"
                              inputProps={{ maxLength: 20 }}
                              autoFocus
                              inputRef={isForPopup ? setInputRef : setInputRef}
                              onChange={(e) => {
                                props.handleChange(e);
                              }}
                              value={props.values.code}
                              onBlur={props.handleBlur}
                              error={
                                props.errors.code && props.touched.code
                                  ? true
                                  : false
                              }
                            />
                            {props.errors.code && props.touched.code && (
                              <Typography
                                className={
                                  props.errors.code && props.touched.code
                                    ? "validation-message text-input error"
                                    : "validation-message text-input"
                                }
                              >
                                {props.errors.code}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          <FormControl fullWidth>
                            <TextField
                              autoFocus
                              required
                              id="name"
                              label="Name"
                              placeholder=""
                              fullWidth
                              size="small"
                              inputProps={{ maxLength: 100 }}
                              onChange={(e) => {
                                props.handleChange(e);
                                if (isForPopup) {
                                  handleUnitChange(e.target.value);
                                }
                              }}
                              value={props.values.name}
                              onBlur={props.handleBlur}
                              error={
                                props.errors.name && props.touched.name
                                  ? true
                                  : false
                              }
                            />
                            {props.errors.name && props.touched.name && (
                              <Typography
                                className={
                                  props.errors.name && props.touched.name
                                    ? "validation-message text-input error"
                                    : "validation-message text-input"
                                }
                              >
                                {props.errors.name}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        columnGap={2}
                        marginTop={2}
                        paddingY={2}
                        style={{
                          width: "100%",
                          backgroundColor: "white",
                          position: isForPopup ? "sticky" : "static",
                          bottom: "0px",
                          zIndex: 9,
                          borderTop: isForPopup ? "1px solid #ced4da" : "none",
                          boxShadow: isForPopup
                            ? " 0px -10px 5px -10px #ced4da"
                            : "none",
                        }}>
                        <Grid item xs={5.5} textAlign="right">
                          <LoadingButton
                            id="categoriesButton"
                            color="primary"
                            type="submit"
                            loading={isSubmitting}
                            variant="contained"
                            disabled={isSubmitting}
                             onClick={async (e) => {
    if (isSubmitting) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    await validateAndSubmitIncomeExpenseItemForm(props);
  }}
                            >
                            <ShortcutButton label="F10" variant="dark" />
                            {buyerSupplierPartyId > 0 ? "Update" : "Save"}
                          </LoadingButton>
                        </Grid>
                        <Grid item xs={5.5}>
                          <Button variant="outlined" onClick={PartyType} disabled={isSubmitting}>
                            <ShortcutButton label="ESC" />
                            Cancel
                          </Button>
                        </Grid>
                      </Grid>
                    </Form>
                  </Paper>
                </Grid>
              </Box>
            </React.Fragment>
          );
        }}
      </Formik>
    </>
  );
}

